import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Enums } from "Interfaces/Utils/Enums";
import { Integration } from "Interfaces/Utils/Integrations";
import { PublicFolderDataSliceStateType } from "../Interfaces/Redux/sliceStateTypes";

const initialState: PublicFolderDataSliceStateType = {
    enums: null,
    integrations: null,
    loading: false,
    error: null,
};

export const loadPublicFolderData = createAsyncThunk(
    "data/loadPublicFolderData",
    async (_, { rejectWithValue }) => {
        try {
            const [enumsResponse, integrationsResponse] = await Promise.all([
                fetch("/data/enums.json", { cache: "no-store" }),
                fetch("/data/integrations.json", { cache: "no-store" }),
            ]);

            if (!enumsResponse.ok || !integrationsResponse.ok) {
                throw new Error("Failed to fetch data");
            }

            const enumsData: Enums = await enumsResponse.json();
            const integrationsData: Integration[] =
                await integrationsResponse.json();

            return { enums: enumsData, integrations: integrationsData };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            return rejectWithValue(error.message || "Failed to load data");
        }
    },
);

export const publicFolderDataSlice = createSlice({
    name: "publicFolderData",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadPublicFolderData.fulfilled, (state, action) => {
                state.enums = action.payload.enums;
                state.integrations = action.payload.integrations;
                state.loading = false;
            })
            .addCase(loadPublicFolderData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loadPublicFolderData.rejected, (state, action) => {
                state.error = action.payload as string;
                state.loading = false;
            });
    },
});

export default publicFolderDataSlice.reducer;
